
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ComponentType, VariantType } from '@/types/typography'

@Component<Typography>({
    components: {},
})
export default class Typography extends Vue {
    @Prop({ type: String, required: false, default: 'body1' })
    public readonly variant!: VariantType
    @Prop({ type: String, required: false, default: 'p' })
    public readonly component!: ComponentType
}
